module.exports = __webpack_public_path__ + "img/no_data.d475587e.png";